import React from 'react';
import {observer} from 'mobx-react';
import {PropTypes} from 'prop-types';

import {ActionButton} from '../action-button/action-button';
import {utilsService} from '../../core/services/utils.service';

const REASON_CHAR_LIMIT = 1000;

@observer
export class AppModal extends React.Component {

	static propTypes = {
		name: PropTypes.string.isRequired,
		platform: PropTypes.string.isRequired,
		version: PropTypes.string.isRequired,
		icon: PropTypes.string,
		title: PropTypes.string.isRequired,
		type: PropTypes.string.isRequired,
		body: PropTypes.object,
		cancelButtonText: PropTypes.string.isRequired,
		confirmationButtonText: PropTypes.string.isRequired,
		confirmationActionButtonText: PropTypes.string.isRequired,
		handleToggleModal: PropTypes.func.isRequired,
		handleConfirmationClick: PropTypes.func.isRequired,
		disableConfirmationButton: PropTypes.bool,
		modalIsVisible: PropTypes.bool,
	};

	constructor(props) {
		super(props);
		this.state = {errorMessage:'', notification:''};
		this.hasTextArea = this.props.type === 'removeApp';
	}

	handleCancelClick = () => {
		this.setState({errorMessage:''});
		if(this.textareaRef) {this.textareaRef.value = '';}
		this.props.handleToggleModal(this.props.type);
	};

	handleConfirmationClick = () => {
		if(this.hasTextArea && !this.textareaRef.validity.valid){
			this.setState({errorMessage:'Please provide a reason for app removal.'});
		} else {
			const confirmationArgs = this.props.type === 'removeApp' ? this.textareaRef.value : null;
			this.setState({errorMessage:''});
			this.setState({notification:''});
			this.props.handleConfirmationClick(confirmationArgs);
		}
	};

	onReasonTextAreaChange = (e) => {
		if(e.target.value.length >= REASON_CHAR_LIMIT){
			this.setState({notification:'Character limit reached.'});
		} else {
			this.setState({notification:''});
		}
	};

	render () {
		const platform = utilsService.renderPlatformName(this.props.platform);
		if (!this.props.modalIsVisible) return null;
		return (
			<div className="modal-wrapper new-app-modal">
				<div className="modal fade show" style={{display: 'block'}} role="dialog" aria-modal="true">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<button type="button" className="fn-modal-close" onClick={this.handleCancelClick}>
								<i aria-hidden="true" className="icon-close"></i>
								<span className="sr-only">Close window</span>
							</button>
							<div className="modal-header text-center">
								<h1 className="as-h2 modal-title">{this.props.title}</h1>
							</div>
							<div className="modal-body">
								{this.props.body}
								<div className="modal-app-info">
									{this.props.icon && <img src={this.props.icon} alt={`${this.props.name} application icon`} />}
									<ul>
										<li><p><strong>{this.props.name}</strong></p></li>
										<li><p>{platform}{(this.props.version && ` / Version ${this.props.version}`)}</p></li>
									</ul>
								</div>
								{this.hasTextArea &&
									(<div>
										<div className={`form-group ${(this.state.notification && 'warning-feedback')} modal-reason`}>
											<label htmlFor="reason" className="col-form-label">
												<strong className="required">Reason for removal</strong>
												<span className="sr-only">This is a required field</span>
												<small className="help-text">Max {REASON_CHAR_LIMIT} characters.</small>
												<div className="msgBlock error error-list">
													{this.state.notification &&
														<span role="status" aria-live="polite">
															{this.state.notification}
														</span>}
													{this.state.errorMessage &&
														<span aria-live="assertive">
															{this.state.errorMessage}
														</span>}
												</div>
											</label>
											<textarea
												name="reason"
												ref={(i) => {this.textareaRef = i}}
												rows="4"
												maxLength={REASON_CHAR_LIMIT}
												onChange={this.onReasonTextAreaChange}
												required></textarea>
										</div>
									</div>)
								}
							</div>
							<div className="row no-gutters modal-actions text-center">
								<button type="button" className="fn-primary" onClick={this.handleCancelClick}>
									{this.props.cancelButtonText}
								</button>
								<ActionButton
									type="button"
									className="fn-secondary"
									label={this.props.confirmationButtonText}
									loadingLabel={this.props.confirmationActionButtonText}
									isLoading={this.props.disableConfirmationButton}
									onClick={this.handleConfirmationClick} />
							</div>
						</div>
					</div>
				</div>
				<div className="modal-backdrop fade show"></div>
			</div>
		);
	}

}
